import http from './../../base/api/public'

let apiUrl = require('@/../config/sysConfig')
// menu列表
export const login_check = (params) => {
    return http.requestPost(apiUrl.apiUrl_LoginCheck, params)
}


//パスワードフラグ検索
export const pwFlagGet = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_PwFlag + '?userId=' + userCd)
}




// WEBPACK FOOTER //
// ./src/components/api/login.js